module.exports = __webpack_public_path__ + "img/newspaper-bottom.929fd3c7.png";